import { useSelector } from 'react-redux';
import {
  cartPricingSelector,
  compositionSettingsSelector,
} from '../../state/modules/pricing/selectors';
import {
  leftForFreeDeliverySelector,
  totalDeliveryCostSelector,
} from '../../state/modules/order/selectors';
import { isDiscountCashbackSystemSelector } from '../../state/modules/city/selectors';

export default function useCheckoutPricing() {
  const pricing = useSelector(cartPricingSelector);
  const { compositionSummary, productTypeSettings } = useSelector(compositionSettingsSelector);
  const totalDeliveryCost = useSelector(totalDeliveryCostSelector);
  const leftForFreeDelivery = useSelector(leftForFreeDeliverySelector);
  const isDiscountCashbackSystem = useSelector(isDiscountCashbackSystemSelector);
  const composition = useSelector(state => state.cart?.composition);
  const sailplayDiscount = useSelector(state => state.cart?.sailplay_discount) || 0;
  const price = useSelector(state => state.cart?.price) || 0;

  const total = pricing.total;
  const totalWithDelivery = total + totalDeliveryCost;

  const isBonusesVisible = isDiscountCashbackSystem;
  const isUsingBonuses =
    Boolean(sailplayDiscount) || composition?.some(item => item.type === 'bonus') || false;

  const bonusesAllowedByProductTypes =
    productTypeSettings?.discounts?.bonuses?.allowed !== false;
  const hasEligibleBonusItems = pricing.eligibleForBonusesTotal > 0;
  const canApplyBonuses = bonusesAllowedByProductTypes && hasEligibleBonusItems;
  const isDisabled = !canApplyBonuses;

  return {
    pricing,
    price,
    total,
    priceIncludingBonuses: total,
    totalDeliveryCost,
    totalWithDelivery,
    leftForFreeDelivery,
    sailplayDiscount,
    maxBonuses: pricing.maxSpendableBonuses,
    maxCashbackCanUse: pricing.maxCashbackCanUse,
    bonusesRest: pricing.unusedBonuses,
    maxBonusesMinusGifts: pricing.maxBonusesMinusGifts,
    giftsForBonusesSum: pricing.giftsForBonusesSum,
    eligibleForBonusesTotal: pricing.eligibleForBonusesTotal,
    minOrderSum: pricing.minOrderSum,
    isBonusesVisible,
    isInvisible: !isBonusesVisible,
    isUsingBonuses,
    canApplyBonuses,
    isDisabled,
    compositionSummary,
    productTypeSettings,
  };
}
